import { RoomTypename } from "shared/types/Project"

import { useAttachmentsByShareLinkQuery } from "entities/attachments/api/useAttachmentsByShareLinkQuery"
import { useProjectAttachmentsByShareLinkQuery } from "entities/attachments/graphql/project-attachments.queries.generated"
import { useAggregatedSharedRoomData } from "entities/rooms/api/useAggregatedSharedRoomData"

import { RoomModel } from "../types/RoomModel"

export interface UseSharedRoomOptions {
  includePrice?: boolean
}

export function useSharedRoom({
  roomID,
  projectID,
  options
}: {
  roomID: string
  projectID: string
  options?: UseSharedRoomOptions
}): RoomModel {
  const data = useAggregatedSharedRoomData({ roomID, projectID, options })

  const {
    data: linkedAttachmentsData,
    loading: isloadingLinkedAttachments,
    error: linkedAttachmentsError
  } = useAttachmentsByShareLinkQuery({
    id: roomID,
    projectShareID: projectID,
    resourceType: RoomTypename
  })

  const {
    data: attachmentsData,
    loading: isloadingAttachments,
    error: attachmentsError
  } = useProjectAttachmentsByShareLinkQuery({
    variables: { id: projectID }
  })

  return {
    core: {
      data: { room: data.room },
      handlers: {
        onEdit: undefined,
        onDelete: undefined,
        onDuplicate: undefined,
        onCopy: undefined,
        onAddClarificationRequest: undefined
      }
    },
    pricing: {
      data: { price: data.price }
    },
    clarificationRequest: null,
    attachments: {
      data: {
        linkedAttachments: {
          data: linkedAttachmentsData?.attachmentsByShareLink,
          isLoading: isloadingLinkedAttachments,
          isUpdating:
            !!linkedAttachmentsData?.attachmentsByShareLink &&
            isloadingLinkedAttachments,
          error: !!linkedAttachmentsError
        },
        attachments: {
          data: attachmentsData?.attachments,
          isLoading: isloadingAttachments,
          isUpdating: !!attachmentsData?.attachments && isloadingAttachments,
          error: !!attachmentsError
        }
      },
      handlers: { onAssignAttachments: undefined }
    }
  }
}
